import { useNavigate } from 'react-router-dom';
import { Button } from 'src/components/Button';
import { Heading } from 'src/components/Heading';
import { withIntegrationApp } from 'src/hocs/withIntegrationApp';
import { useWizard } from '../components/wizard/WizardContext';
import ContactsContent from './CampaignOverview/components/ContactsContent';

const AddContactsContent = () => {
  const navigate = useNavigate();

  const { currentStep, prevStep, saveCampaignAutomation } = useWizard();

  const handleSkipCreateCampaign = async () => {
    const campaignSaved = await saveCampaignAutomation();

    if (campaignSaved)
      navigate(`/beta/campaigns/overview/${campaignSaved.referenceId}`);
  };

  const handleSaveAndExit = async () => {
    const campaignSaved = await saveCampaignAutomation();
    if (campaignSaved) navigate('/beta/campaigns');
  };

  return (
    <div className="flex-1">
      <Heading
        title="Add your contacts"
        subtitle={`${currentStep}/3`}
        backAction={prevStep}
        fixedHeader
      >
        <div className="flex gap-2 mt-3">
          <Button variant="outlined" size="small" onClick={handleSaveAndExit}>
            Save & Exit
          </Button>
          <Button variant="outlined" size="small" onClick={prevStep}>
            Back
          </Button>
          <Button size="small" onClick={handleSkipCreateCampaign}>
            Skip & Create Campaign
          </Button>
        </div>
      </Heading>

      <ContactsContent isEditing={false} />
    </div>
  );
};

export default withIntegrationApp(AddContactsContent);
